import React, {useEffect, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import {useSelector} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FastImage from '../../../common/FastImage';
import CommonModal from '../../../commonComponents/commonModal';
import {Input} from '../../../components/core/Input';
import Header from '../../../commonComponents/Header';
import RadioButton from '../../../commonComponents/RadioButton';
import {order_yes_contract, waitingClock} from '../../../utils/images';
import {Network} from '../../../utils/network';
import WaitTimeClockBottomSheet from './waitTimeClockBottomSheet';
import colors from '../../../assets/Color/Colors';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {Button} from '../../../components/core/Button';

const EventCreate = ({navigation, route}) => {
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({mode: 'onChange'});
  const insets = useSafeAreaInsets();
  const [isEventCreated, setIsEventCreated] = useState(null);
  const isNormalEvent = route?.params?.isNormal || false;
  const [errorObj, setErrorObj] = useState(null);
  let userInfo = useSelector(({profile}) => profile.profileData);
  const detail = isNormalEvent
    ? userInfo?.create_normal_event_defaults
    : userInfo?.create_event_defaults;
  const [seletedIndex, setSelectedIndex] = useState(0);
  const [showClockBottomSheet, setShowClockBottomSheet] = useState(false);

  const onSubmit = async data => {
    setErrorObj(null);
    const createData = {
      title: data?.marketTitle,
      invest_amount: detail?.invest_amount,
      duration: {
        day: +data?.eventEndTime,
      },
      invest_option: seletedIndex === 0 ? 'Y' : 'N',
      probe_type: isNormalEvent ? 'normal' : null,
      source_of_settlement: data?.sourceOfSettlement,
    };
    setShowClockBottomSheet(true);
    const res = await Network.createTokenEvent(createData, false);

    if (res?.data?.success) {
      //setShowClockBottomSheet(false);
      //onEventRedirectionClick(res?.data);
      //setIsEventCreated(res?.data);
      //setErrorObj(null);
    } else {
      setErrorObj(res?.data);
      //setShowClockBottomSheet(true);
    }
  };

  useEffect(() => {
    if (userInfo) {
      let defaultValues = {};
      const details = detail;

      defaultValues.investedAmount = details?.invest_amount
        ? details?.invest_amount
        : 1;
      defaultValues.eventEndTime = details?.duration?.days
        ? details?.duration?.days
        : 1;

      reset({...defaultValues});
    }
  }, [userInfo]);

  useEffect(() => {
    if (detail?.invest_option) {
      setSelectedIndex(detail?.invest_option === 'Y' ? 0 : 1);
    }
  }, [detail?.invest_option]);

  const TitleBox = ({title, text}) => {
    return (
      <View style={{marginBottom: 15, marginTop: 25}}>
        <Text style={[globalFontStyle.appFontSubHeading, {color: Color.black}]}>
          {title}
        </Text>
        <Text style={globalFontStyle.appFontSmallText}>{text}</Text>
      </View>
    );
  };
  const onEventRedirectionClick = data => {
    navigation.pop();
    navigation.navigate('Event', {
      eventId: data?.probeId,
      isMulti: false,
    });
  };
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      style={{
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        paddingLeft: insets.left,
        paddingRight: insets.right,
      }}
      contentContainerStyle={{flexGrow: 1}}>
      <View
        style={{flex: 1, position: 'relative', backgroundColor: Color.bgWhite}}>
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={''}
          isBackgroundColor={false}
          translate={true}
        />
        <View
          style={{
            paddingHorizontal: 12,
            marginTop: 0,
            marginBottom: 100,
            flex: 1,
          }}>
          <TitleBox title={'Enter event title'} />
          <Controller
            control={control}
            name="marketTitle"
            rules={{
              required: 'Please enter title',
              minLength: {
                value: 5,
                message: 'Length must be 5 or more',
              },
            }}
            render={({field: {value, onChange}}) => (
              <Input
                value={value}
                onChangeText={onChange}
                variant={errors?.marketTitle ? "error" : "default"}
                size="default"
                multiline={true}
                numberOfLines={3}
                style={{minHeight: 80}}
              />
            )}
          />
          {errors?.marketTitle?.type === 'required' && (
            <Text style={globalStyle.errorText}>Please enter event title</Text>
          )}
          {errors?.marketTitle?.type === 'minLength' && (
            <Text style={globalStyle.errorText}>Minimum length is 5 words</Text>
          )}
          <TitleBox title={'Event will expire in'} />
          <Input
            name="eventEndTime"
            control={control}
            variant="default"
            size="default"
            numeric={true}
            placeholder="2 days"
            rightElement={
              <Text style={[globalFontStyle.appFontSubText, {color: Color.blue1, marginRight: 10}]}>
                days
              </Text>
            }
            rules={{
              required: 'Please enter end time for event in days',
              min: {
                value: 1,
              },
            }}
          />
          {errors?.eventEndTime?.type === 'required' && (
            <Text style={globalStyle.errorText}>
              Please enter end time for event in days
            </Text>
          )}
          {errors?.eventEndTime?.type === 'min' && (
            <Text style={globalStyle.errorText}>
              Please enter value greater than 0
            </Text>
          )}
          <View style={{marginBottom: 13, marginTop: 25}}>
            <Text
              style={[globalFontStyle.appFontSubHeading, {color: Color.black}]}>
              Place your trade of {''}
              <Text style={{color: Color.tradexBlue}}>
                {detail?.invest_amount}{' '}
                {isNormalEvent ? 'credits ' : 'token points '}
              </Text>
              on
            </Text>
          </View>
          <View style={{}}>
            {['Yes', 'No'].map((item, index) => {
              const isSelected = seletedIndex === index;
              return (
                <TouchableOpacity
                  style={[
                    styles.radioOuterBox,
                    isSelected ? {borderColor: Color.tradexBlue} : null,
                    index < 1 ? {marginBottom: 16} : {},
                  ]}
                  activeOpacity={0.8}
                  key={item}
                  onPress={() => {
                    setSelectedIndex(index);
                  }}>
                  <View style={{flexDirection: 'row', alignItems: 'center'}}>
                    <Text
                      style={[
                        {marginLeft: 10},
                        isSelected ? {color: Color.tradexBlue} : null,
                      ]}>
                      {item}
                    </Text>
                  </View>

                  {isSelected && (
                    <FastImage
                      style={{
                        height: 20,
                        width: 20,
                      }}
                      source={order_yes_contract()}
                    />
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
          <TitleBox title={'Settlement Source Link'} />
          <Input
            name="sourceOfSettlement"
            control={control}
            variant="default"
            size="default"
            placeholder="www.dwdw.com"
            rules={{
              required: 'Please enter the source of settlement',
              minLength: {
                value: 5,
                message: 'Length must be 5 or more',
              },
            }}
          />
          {errors?.sourceOfSettlement?.type === 'required' && (
            <Text style={globalStyle.errorText}>
              Please enter the source of settlement
            </Text>
          )}
          {errors?.sourceOfSettlement?.type === 'minLength' && (
            <Text style={globalStyle.errorText}>Minimum length is 5 words</Text>
          )}
        </View>
        <View style={[{marginBottom: 30, marginHorizontal: 10}]}>
          <Button
            variant="primary"
            onPress={handleSubmit(onSubmit)}
            disabled={!isValid}
            translate={true}
          >
            Create Event
          </Button>
        </View>
        <CommonModal
          showModal={showClockBottomSheet}
          customModalStyle={[globalStyle.modalView, {alignItems: 'stretch'}]}
          persistent={true}>
          <WaitTimeClockBottomSheet
            onOkayClick={param => {
              if (param) {
                navigation.pop();
              }
              setShowClockBottomSheet(false);
            }}
            error={errorObj?.info}
          />
        </CommonModal>
      </View>
    </ScrollView>
  );
};

export default EventCreate;

const styles = StyleSheet.create({
  radioOuterBox: {
    flexDirection: 'row',
    paddingHorizontal: 10,
    paddingVertical: 14,
    borderRadius: 6,
    alignItems: 'center',
    borderColor: colors.borderColor,
    borderWidth: 1,
    justifyContent: 'space-between',
  },
});
